// sagas.js
import { takeLatest, put } from 'redux-saga/effects';
import { getAllCompaniesDataSuccess, getAllCompaniesDataError, getAllDealerShipsDataSuccess, getAllDealerShipsDataError, getVariantsDataSuccess, getVariantsDataError, getDMSDataSuccess, getDMSDataError, getAllDealerShipsDataUsersSuccess, getAllDealerShipsDataUsersError, getAllDealerShipsDataLoading, getAllBrandsDataSuccess, getAllBrandsDataError } from './action';
import { getActiveBrand, getActiveCompany, getAllBrand, getAllCompanys, getAllDealers, getAllModel, getAllUser, getAllVariant } from '../../api';
import { GET_ALL_BRANDS, GET_ALL_COMPANIES, GET_ALL_DEALERSHIPS, GET_ALL_DEALERSHIPS_USERS, GET_ALL_DMS_DATA } from '../actionTypes';
import Axios from 'axios';



function* getAllCompaniesSaga(action) {
  try {
    const { page, rowsPerPage, searchText, columnFilters, sorting, setCount, setData, setIsLoading } = action.payload;    
    // setIsLoading(true);
    const data = yield getActiveCompany(page, rowsPerPage, searchText || '', columnFilters, sorting);
    if (data) {
      // yield put(getAllCompaniesDataSuccess(data.data?.result?.products));
      // setData(data.data?.result?.products);
      // setCount(data.data?.result?.totalRows);
      yield put(getAllCompaniesDataSuccess(data.data?.result));
      // setData(data.data?.result);
      // setCount(data.data?.result.length);
      
      // setIsLoading(false);
    }
        
  } catch (error) {
    yield put(getAllCompaniesDataError(error.response.data.error)); 
  }
}
function* getAllBrandsSaga(action) {
  try {
    const { page, rowsPerPage, searchText, columnFilters, sorting, setCount, setData, setIsLoading } = action.payload;    
    // setIsLoading(true);
    const data = yield getActiveBrand();
    // const data = yield getAllBrand(page, rowsPerPage, searchText || '', columnFilters, sorting);
    if (data) {
      // console.log('getAllCompanys', data.data.result);
      // console.log('data.data?.result.length', data.data?.result.length);
      // console.log('data.data?.length', data.data?.length);
      // yield put(getAllCompaniesDataSuccess(data.data?.result?.products));
      // setData(data.data?.result?.products);
      // setCount(data.data?.result?.totalRows);
      let brand_data = data.data?.result;
      if (brand_data && Array.isArray(brand_data)) {
        brand_data = brand_data.sort((a, b) => {
          if (a.name && b.name) {
            return a.name.localeCompare(b.name);
          }
          return 0;
        });
      }
      // yield put(getAllBrandsDataSuccess(data.data?.result));
      yield put(getAllBrandsDataSuccess(brand_data));
      // setData(data.data?.result);
      // setCount(data.data?.result.length);
      
      // setIsLoading(false);
    }
        
  } catch (error) {
    console.log(error)
    yield put(getAllBrandsDataError(error.response?.data?.error)); 
  }
}


function* getAllDealershipsSaga(action) {
  
  const { page, rowsPerPage, searchText, columnFilters, sorting, setCount, setIsLoading } = action.payload;

  try {
    yield put(getAllDealerShipsDataLoading());
    setIsLoading(true);
    const data = yield getAllDealers(page , rowsPerPage , searchText, columnFilters, sorting)
    const companyData = yield getAllCompanys()
      const temp = []
      yield data.data.result.dealer.map(ele => {
        const result = companyData?.data?.result?.filter(item => item.company_id === ele.company_id)
        temp.push({ ...ele, client_company_name: result[0]?.client_company_name })
      })
      setCount(data.data?.result?.totalCount);   
      // setTotalData(temp)
      // setDataHolder(temp)
      // settotalPage(Array.from({ length: Math.ceil(temp.length / 6) }, (v, i) => i + 1))
      // const dealershipData = getCount(1, temp)
      setIsLoading(false);
      if (temp) {
        yield put(getAllDealerShipsDataSuccess(temp));
        setIsLoading(false);
      }
  } catch (error) {
    yield put(getAllDealerShipsDataError(error?.response?.data?.error)); 
  }
}

function* getAllDealershipsUsersSaga(action) {
  try {
    const { dataHolder,currentPage,setcurrentPage,setTotalData,setDataHolder,settotalPage,getCount } = action.payload;
    if (currentPage >= 0) {
      if ((dataHolder.length === 30 || dataHolder.length === 0)) {
        const dataFromUsers = yield getAllUser(currentPage)
          const temp = dataFromUsers.data.result.users.filter(ele => {
            let flag = false
            ele.users_has_Roles.forEach(roles => {
              if (roles.role.alias === "DEALERSHIP_MANAGER" || roles.role.alias === "TEAM_MEMBER") {
                flag = true
              }
            });
            if (flag) {
              return true
            }
            else {
              return false
            }
          })
          setcurrentPage(currentPage);
          setTotalData(temp)
          setDataHolder(temp)
          settotalPage(Array.from({ length: Math.ceil(temp.length / 10) }, (v, i) => i + 1))
          const dealershipsUsersData = getCount(1, temp)
          if (dealershipsUsersData) {
            yield put(getAllDealerShipsDataUsersSuccess(dealershipsUsersData));
            }
      }
    }
  } catch (error) {
    console.log(error)
    yield put(getAllDealerShipsDataUsersError(error.response.data.error)); 
  }
}

// function* getAllBrandsSaga(action) {
//   // try {
//   //   const { setTotalData, setDataHolder, settotalPage,getCount } = action.payload;
//   //   const data = yield getAllBrand()
//   //     // setTotalData(data.data.result)
//   //     // setDataHolder(data.data.result)
//   //     // settotalPage(Array.from({ length: Math.ceil(data.data.result.length / 6) }, (v, i) => i + 1))
//   //     const tempdata = getCount(1, data.data.result)
//   //     console.log("data",data)
//   //     if (tempdata) {
//   //       yield put(getAllBrandsDataSuccess(tempdata));
//   //       }
//   // } catch (error) {
//   //   console.log(error)
//   //   yield put(getAllBrandsDataError(error.response.data.error)); 
//   // }
//   try {
//     const { page, rowsPerPage, searchText, columnFilters, sorting, setCount, setData, setIsLoading } = action.payload;
//     setIsLoading(true);
//     const data = yield getAllBrand(page, rowsPerPage, searchText, columnFilters, sorting);
//     if (data) {
//       setData(data.data.result.data);
//       setCount(data.data?.result?.totalRows);
//       yield put(getAllBrandsDataSuccess(data.data.result.data));
//       setIsLoading(false);
//     }
//   } catch (error) {
//     console.log(error)
//     yield put(getAllBrandsDataError(error));
//   }
// }

// function* getFuelSaga(action) {
//   try {
//     const { page, rowsPerPage, searchText, columnFilters, sorting, setCount, setData, setIsLoading } = action.payload;
//     setIsLoading(true);
//     const data = yield getAllFuel(page, rowsPerPage, searchText, columnFilters, sorting)
//     const brandData = yield getAllBrand()
//       const temp = []
//       yield data.data.result.data.map(ele => {
//         const result = brandData.data.result.data.filter(item => item.brand_id === ele.brand_id)
//         temp.push({ ...ele, brand_name: result[0].name })
//         console.log(result, ele, "82")
//       })
//       // setTotalData(temp)
//       // setDataHolder(temp)
//       // settotalPage(Array.from({ length: Math.ceil(temp.length / 6) }, (v, i) => i + 1))
//       // const fuelsData = getCount(1, temp)
//       setCount(data.data?.result?.totalRows);
//       if (temp) {
//         yield put(getFuelsDataSuccess(temp));
//         setIsLoading(false);
//         }
//   } catch (error) {
//     console.log(error)
//     yield put(getFuelsDataError(error.response.data.error)); 
//   }
// }

// function* getAllTransmissionSaga(action) {
//   try {
//     const { page, rowsPerPage, searchText, columnFilters, sorting, setCount, setData, setIsLoading } = action.payload;
//     setIsLoading(true);
//     const data = yield getAllTransmissin(page, rowsPerPage, searchText, columnFilters, sorting)
    
//       // setTotalData(temp)
//       // setDataHolder(temp)
//       // settotalPage(Array.from({ length: Math.ceil(temp.length / 6) }, (v, i) => i + 1))
//       // const transmissionData = getCount(1, temp)
//       yield put(getAllTransmissionDataSuccess(data.data.result.data));
//       setIsLoading(false);
//       setCount(data.data?.result?.totalRows);
      
      
//   } catch (error) {
//     console.log(error)
//     yield put(getAllTransmissionDataError(error.response.data.error)); 
//   }
// }

// function* getAllModelsSaga(action) {
//   try {
//     return;
//     const { page, rowsPerPage, searchText, columnFilters, sorting, setCount, setData, setIsLoading } = action.payload;
//     setIsLoading(true);
//     const data = yield getAllModel(page, rowsPerPage, searchText, columnFilters, sorting)
//     console.log("first",data)
//     const brandData = yield getAllBrand()
//       const temp = []
//       yield data.data.result.data.map(ele => {
//         const result = brandData.data.result.data.filter(item => item.brand_id === ele.brand_id)
//         temp.push({ ...ele, brand_name: result[0].name })
//         console.log(result, ele, "82")
//       })
//       // setTotalData(temp)
//       // setDataHolder(temp)
//       // settotalPage(Array.from({ length: Math.ceil(temp.length / 6) }, (v, i) => i + 1))
//       // const modelsData = getCount(1, temp)
//       setCount(data.data?.result?.totalRows);
//       if (temp) {
//         setIsLoading(false);
//         yield put(getModelsDataSuccess(temp));
//         }
//   } catch (error) {
//     console.log(error)
//     yield put(getModelsDataError(error.response.data.error)); 
//   }
// }

// function* getAllVariantsSaga(action) {
//   try {
//     const { page, rowsPerPage, searchText, columnFilters, sorting, setCount, setData, setIsLoading } = action.payload;
//     setIsLoading(true);
//     const data = yield getAllVariant(page, rowsPerPage, searchText, columnFilters, sorting)
//     const brandData = yield getAllBrand()
//       const temp = []
//       const mainTemp = []
//       yield data.data.result.data.map(ele => {
//         const result = brandData.data.result.data.filter(item => item.brand_id === ele.brand_id)
//         temp.push({ ...ele, brand_name: result[0].name })
//         console.log(result, ele, "82")
//       })
//       const modelData = yield getAllModel()
//       yield temp.map(ele => {
//           const result = modelData.data.result.data.filter(item => item.model_id === ele.model_id)
//           mainTemp.push({ ...ele, model_name: result[0].name })
//         })
//       //   setTotalData(mainTemp)
//       //   setDataHolder(mainTemp)
//       //   settotalPage(Array.from({ length: Math.ceil(mainTemp.length / 10) }, (v, i) => i + 1))
//       // const variantsData = getCount(1, mainTemp)
//       setCount(data.data?.result?.totalRows);
//       if (mainTemp) {
//         setIsLoading(false);
//         yield put(getVariantsDataSuccess(mainTemp));
//         }
//   } catch (error) {
//     console.log(error)
//     yield put(getVariantsDataError(error.response.data.error)); 
//   }
// }

function* getAllDMSDataSaga(action) {
  try {
    const data = yield Axios.get(`${process.env.PUBLIC_URL}/api/EPortal2.0/ADMIN/AFFILIATIONS/DMSDATA/AllDMSData.json`)
      if (data) {
        yield put(getDMSDataSuccess(data.data.data));
        }
  } catch (error) {
    console.log(error)
    yield put(getDMSDataError(error.response.data.error)); 
  }
}

export function* watchAffiliationsData() {
  yield takeLatest(GET_ALL_COMPANIES, getAllCompaniesSaga);
  yield takeLatest(GET_ALL_BRANDS, getAllBrandsSaga);
  yield takeLatest(GET_ALL_DEALERSHIPS, getAllDealershipsSaga);
  yield takeLatest(GET_ALL_DEALERSHIPS_USERS, getAllDealershipsUsersSaga);
  yield takeLatest(GET_ALL_BRANDS, getAllBrandsSaga);
  // yield takeLatest(GET_FUEL, getFuelSaga);
  // yield takeLatest(GET_ALL_TRANSMISSION, getAllTransmissionSaga);
  // yield takeLatest(GET_ALL_MODELS, getAllModelsSaga);
  // yield takeLatest(GET_ALL_VARIANTS, getAllVariantsSaga);
  yield takeLatest(GET_ALL_DMS_DATA, getAllDMSDataSaga);
}

